import * as PropTypes from 'prop-types';
import * as React from 'react';
import CSRFForm from '../../shared/csrf_form';
import { UserStore } from '@reverbdotcom/discovery-ui';

class AddToCartButton extends React.Component {
  render() {
    if (!this.props.productId) { return null; }

    return (
      <CSRFForm method="POST" action="/cart" className="add-to-cart">
        <input
          type="hidden"
          name="cart_item[action_source_attributes][device]"
          value={UserStore.getState().deviceType}
        />
        <input
          type="hidden"
          name="cart_item[product_id]"
          value={this.props.productId}
        />
        {this.props.suggestedListing &&
          <input
            type="hidden"
            name="cart_item[suggested_listing]"
            value={this.props.suggestedListing}
          />
        }

        <input
          type="submit"
          value={I18n.t('productShowPage.addToCart')}
          className="add-to-cart-button"
        />
      </CSRFForm>
    );
  }
}

AddToCartButton.propTypes = {
  productId: PropTypes.number,
  className: PropTypes.string,
  suggestedListing: PropTypes.bool,
};

export default AddToCartButton;



// WEBPACK FOOTER //
// ./javascripts/components/listings/cart/add_to_cart_button.jsx